import { render } from "./EmsDashboardPage.vue?vue&type=template&id=189158c5&scoped=true&ts=true"
import script from "./EmsDashboardPage.vue?vue&type=script&lang=ts"
export * from "./EmsDashboardPage.vue?vue&type=script&lang=ts"

import "./EmsDashboardPage.vue?vue&type=style&index=0&id=189158c5&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189158c5"]])

export default __exports__